import React, { useEffect, useState } from "react"
import { formatDateDataGrid } from "src/utils/format-date"
import PropTypes from 'prop-types'
import DatalakeService from "src/services/datalake-service"
import ParameterPaginationTable from "src/components/table/parameter-pagination-table"

const ParameterDatalakeCVMDFCTRATTable = (props) => {
    const dataLakeService = new DatalakeService()
    const [data, setData] = useState([])
    const [pagination, setPagination] = useState({ count: 0, next: null, previous: null })

    useEffect(() => {
        loadData()
    }, [])

    const loadData = () => {
        props.loading(true)
        dataLakeService.loadPaginationEndpoint(props.endpoint).then((response) => {
            props.loading(false)

            const { body } = response
            const { results, count, next, previous } = body
            const list = results.map((obj, index) => ({ ...obj, id: index }))
            setPagination({ count: count, next: next, previous: previous })
            setData(list)
        })
    }

    const createRow = async () => {
        const body = {
            "ID_DF": null,
            "CPFCNPJ": null,
            "DataReferencia": null,
            "Versao": null,
            "CodigoCVM": null,
            "GrupoDFP": null,
            "Moeda": null,
            "EscalaMoeda": null,
            "OrdemExercicio": null,
            "DataInicioExercicio": null,
            "DataFimExercicio": null,
            "CodigoConta": null,
            "DescricaoConta": null,
            "SaldoConta": null,
            "SituacaoFixaConta": null,
            "NivelConta": null,
            "BaseBalanco": null,
            "GrupoBalanco": null,
            "Ano": null,
            "MetodoDFC": null,
            "PrioridadeBase": null,
            "JanelaDados": null,
            "SaldoContaAnualizadoReais": null
        }

        console.log("DataReferencia:", body.DataReferencia)

        props.loading(true)
        return dataLakeService.createTableEndpoint(props.endpoint, body).then(() => {
            props.loading(false)
            loadData(0, 25)
        }).catch((err) => {
            props.loading(false)
            throw err
        })
    }

    const updateRow = async (newRow) => {
        const { ID, ID_DF, CPFCNPJ, DataReferencia, Versao, CodigoCVM, GrupoDFP, Moeda, EscalaMoeda, OrdemExercicio, DataInicioExercicio, DataFimExercicio, CodigoConta, DescricaoConta, SaldoConta, SituacaoFixaConta, NivelConta, BaseBalanco, GrupoBalanco, Ano, MetodoDFC, PrioridadeBase, JanelaDados, SaldoContaAnualizadoReais
        } = newRow

        const body = {
            "ID_DF": ID_DF,
            "CPFCNPJ": CPFCNPJ,
            "DataReferencia": DataReferencia,
            "Versao": Versao,
            "CodigoCVM": CodigoCVM,
            "GrupoDFP": GrupoDFP,
            "Moeda": Moeda,
            "EscalaMoeda": EscalaMoeda,
            "OrdemExercicio": OrdemExercicio,
            "DataInicioExercicio": DataInicioExercicio,
            "DataFimExercicio": DataFimExercicio,
            "CodigoConta": CodigoConta,
            "DescricaoConta": DescricaoConta,
            "SaldoConta": SaldoConta,
            "SituacaoFixaConta": SituacaoFixaConta,
            "NivelConta": NivelConta,
            "BaseBalanco": BaseBalanco,
            "GrupoBalanco": GrupoBalanco,
            "Ano": Ano,
            "MetodoDFC": MetodoDFC,
            "PrioridadeBase": PrioridadeBase,
            "JanelaDados": JanelaDados,
            "SaldoContaAnualizadoReais": SaldoContaAnualizadoReais
        }

        props.loading(true)
        return dataLakeService.updateTableEndpoint(props.endpoint, ID, body).then(() => {
            props.loading(false)
        }).catch((err) => {
            props.loading(false)
            throw err
        })
    }

    const deleteRow = async (row) => {
        props.loading(true)
        const { ID } = row
        return dataLakeService.deleteTableEndpoint(props.endpoint, ID).then(() => {
            props.loading(false)
            const listRemoved = data.filter((item) => item.ID !== ID)
            setData(listRemoved)
        }).catch((err) => {
            props.loading(false)
            throw err
        })
    }

    const onFilter = async (filterList, limit, offset) => {
        const query = filterList.map(obj => `${encodeURIComponent(obj.field)}=${encodeURIComponent(obj.value)}`).join('&')

        props.loading(true)
        dataLakeService.loadPaginationEndpoint(props.endpoint, query, limit, offset).then((response) => {
            props.loading(false)
            const { body } = response
            const { results, count, next, previous } = body
            const list = results.map((obj) => ({ ...obj, id: obj.ID }))
            setPagination({ count: count, next: next, previous: previous })
            setData(list)
        })
    }

    const changePage = async (endpoint) => {
        props.loading(true)
        dataLakeService.paginate(endpoint).then((response) => {
            props.loading(false)
            const { body } = response
            const { results, count, previous, next } = body
            const list = results.map((obj) => ({ ...obj, id: obj.ID }))

            setPagination({ count: count, next: next, previous: previous })
            setData([])
            setData(list)
        })
    }

    const columns = [
        {
            field: 'ID',
            headerName: '#',
            disableColumnMenu: true,
            disableFilter: true,
            flex: true,
            minWidth: 80,
        },
        {
            field: 'ID_DF',
            headerName: 'ID_DF',
            disableColumnMenu: true,
            flex: true,
            minWidth: 150,
        },
        {
            field: 'CPFCNPJ',
            headerName: 'CPFCNPJ',
            disableColumnMenu: true,
            flex: true,
            minWidth: 150,
        },
        {
            field: 'DataReferencia',
            headerName: 'DataReferencia',
            disableColumnMenu: true,
            flex: true,
            minWidth: 150,
        },
        {
            field: 'Versao',
            headerName: 'Versao',
            disableColumnMenu: true,
            flex: true,
            minWidth: 150,
        },
        {
            field: 'CodigoCVM',
            headerName: 'CodigoCVM',
            disableColumnMenu: true,
            flex: true,
            minWidth: 150,
        },
        {
            field: 'GrupoDFP',
            headerName: 'GrupoDFP',
            disableColumnMenu: true,
            flex: true,
            minWidth: 150,
        },
        {
            field: 'Moeda',
            headerName: 'Moeda',
            disableColumnMenu: true,
            flex: true,
            minWidth: 150,
        },
        {
            field: 'EscalaMoeda',
            headerName: 'EscalaMoeda',
            disableColumnMenu: true,
            flex: true,
            minWidth: 150,
        },
        {
            field: 'OrdemExercicio',
            headerName: 'OrdemExercicio',
            disableColumnMenu: true,
            flex: true,
            minWidth: 150,
        },
        {
            field: 'DataInicioExercicio',
            headerName: 'DataInicioExercicio',
            disableColumnMenu: true,
            flex: true,
            minWidth: 150,
        },
        {
            field: 'DataFimExercicio',
            headerName: 'DataFimExercicio',
            disableColumnMenu: true,
            flex: true,
            minWidth: 150,
        },
        {
            field: 'CodigoConta',
            headerName: 'CodigoConta',
            disableColumnMenu: true,
            flex: true,
            minWidth: 150,
        },
        {
            field: 'DescricaoConta',
            headerName: 'DescricaoConta',
            disableColumnMenu: true,
            flex: true,
            minWidth: 150,
        },
        {
            field: 'SaldoConta',
            headerName: 'SaldoConta',
            disableColumnMenu: true,
            flex: true,
            minWidth: 150,
        },
        {
            field: 'SituacaoFixaConta',
            headerName: 'SituacaoFixaConta',
            disableColumnMenu: true,
            flex: true,
            minWidth: 150,
        },
        {
            field: 'NivelConta',
            headerName: 'NivelConta',
            disableColumnMenu: true,
            flex: true,
            minWidth: 150,
        },
        {
            field: 'BaseBalanco',
            headerName: 'BaseBalanco',
            disableColumnMenu: true,
            flex: true,
            minWidth: 150,
        },
        {
            field: 'GrupoBalanco',
            headerName: 'GrupoBalanco',
            disableColumnMenu: true,
            flex: true,
            minWidth: 150,
        },
        {
            field: 'Ano',
            headerName: 'Ano',
            disableColumnMenu: true,
            flex: true,
            minWidth: 150,
        },
        {
            field: 'MetodoDFC',
            headerName: 'MetodoDFC',
            disableColumnMenu: true,
            flex: true,
            minWidth: 150,
        },
        {
            field: 'PrioridadeBase',
            headerName: 'PrioridadeBase',
            disableColumnMenu: true,
            flex: true,
            minWidth: 150,
        },
        {
            field: 'JanelaDados',
            headerName: 'JanelaDados',
            disableColumnMenu: true,
            flex: true,
            minWidth: 150,
        },
        {
            field: 'SaldoContaAnualizadoReais',
            headerName: 'SaldoContaAnualizadoReais',
            disableColumnMenu: true,
            flex: true,
            minWidth: 150,
        },
        {
            field: 'CriadoEm',
            headerName: 'Data de Criação',
            flex: true,
            minWidth: 150,
            disableColumnMenu: true,
            disableFilter: true,
            renderCell: (params) => formatDateDataGrid(params)
        },
        {
            field: 'AtualizadoEm',
            headerName: 'Data de Atualização',
            flex: true,
            minWidth: 150,
            disableColumnMenu: true,
            disableFilter: true,
            renderCell: (params) => formatDateDataGrid(params)
        }
    ]

    return (
        <div>
            <ParameterPaginationTable
                columns={columns}
                data={data}
                setData={setData}
                createRow={createRow}
                deleteRow={deleteRow}
                updateRow={updateRow}
                filterFunction={onFilter}
                pagination={pagination}
                onChangePage={changePage}
                customFilter={true} />
        </div>
    )
}

ParameterDatalakeCVMDFCTRATTable.propTypes = {
    loading: PropTypes.func,
    endpoint: PropTypes.string,
}

export default ParameterDatalakeCVMDFCTRATTable